shared = {
    // Funkcia na ziskanie popiskov pre gameparty
    getGameParts() {
        try {
            var requestUrl;
            $.getJSON(requestUrl = url.offer + "GameParts/LanguageID/" + offer.lang + (profile.OddsCacheFeed? "": "?callback=?"))
                .done(function (gp) {
                    clearTimeout(rfs.gameParts);
                    delete rfs.gameParts;

                    stored.GameParts = (profile.OddsCacheFeed? gp: JSON.parse(gp));

                    main.createLog(3, "GetGameParts_Done " + offer.lang);
                    return true;
                })
                .fail(function (jqXHR) {
                    clearTimeout(rfs.gameParts);
                    delete rfs.gameParts;
                    main.createLog(2, "GetGameParts_Failed " + offer.lang);
                    jqXHR.requestUrl = requestUrl;
                    rfs.gameParts = setTimeout(function() {
                        shared.getGameParts();
                    }, sets.refreshTime);
                });

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
        }
    },

    // Funkcia na parsovanie skore
    parseScore(score, sportID, simple) {
        try {
            if (score) {
                if (score.match("res_order")) {
                    // Jedna sa o overall event - skore je poradie competitorov
                    score = score.toString().replace(/res_order/g,"").replace(/=/g, ".\xa0#");
                    return { total: score, isOverallEvent: true };
                }

                var s = new Object();
                if (!simple) {
                    s.Home = new Object();
                    s.Away = new Object();
                }

                // TODO - sem parsovanie skorte pre Lucky Loot
                // "restot=24,5,11,22,9,10 FC(R) B(0) G(3) R(2) BX(7)" - asi v ťahu chyba Y(#) a suma(nad/pod 75,5)

                // Odstrani vsetky medzery
                score = score.toString().replace(/\s/g, "");

                // Cards (Yellow)
                if (score.match("Y")) {
                    s.cardsYellow = score.split("Y(")[1].split(")")[0];
                }
                // Cards (Red)
                if (score.match("R")) {
                    s.cardsRed = score.split("R(")[1].split(")")[0];
                }

                if (score.match("S")) {
                    s.powerPlay = score.split("S(")[1].split(")")[0];
                }

                // Cards (Red)
                if (score.match("C")) {
                    s.corners = score.split("C(")[1].split(")")[0];
                }

                // Predlzenie
                if (score.match("overtime")) {
                    s.overtime = [];
                    s.overtimeTitle = [];
                    extract = score.match(/(?<=\()(overtime.*?)(?=\))/g)[0];
                    if (extract.includes("overtime_")) {
                        // Viac predlzeni maju tvar (overtime_1=3:3, overtime_2=2:1)
                        $.each(extract.split(','), function (i, partialOvertime) {
                            s.overtimeTitle.push(partialOvertime.split("=")[0]);
                            s.overtime.push(partialOvertime.split("=")[1]);
                        });
                    } else {
                        // Jedno predlzenie, tvar (overtime=1:2)
                        s.overtime.push(extract.split("=")[1]);
                    }
                }
                // Penialties pri celkovom skore
                if (score.match("penalties")) {
                    s.penalties = score.split("(penalties=")[1].split(")")[0];
                }

                // Rozsirene skore
                score = score.split("[");

                // Celkove skore
                s.total = score[0].split("=");
                s.totalTitle = s.total[0];
                s.total = s.total[1];

                // Sporty s parcial score
                if (score[1]) {

                    score = score[1].split(",{");

                    // Sporty bez game score
                    if (!score[1]) {
                        score = score[0].split("]");
                        s.parcial = score[0];
                        if (score[1] && score[1].substr()[0] == "H" || score[1].substr()[0] == "A") {
                            // Obsahuje service
                            s.service = score[1].substr()[0];
                        }

                    } else {

                        // Game
                        s.parcial = score[0];
                        score = score[1].split("}]");
                        s.game = score[0].split("=");
                        s.gameTitle = s.game[0];
                        s.game = s.game[1];

                        // Pri Tenise sa 50 prepise na A - advantage
                        switch (sportID) {
                            case 58:
                                s.game = s.game.replace("50", "A");
                                break;
                        }

                        // Service (Home vs. Away)
                        if (score[1] && score[1].substr()[0] == "H" || score[1].substr()[0] == "A")
                            s.service = score[1].substr()[0];

                        // Rozdeli gemy podla domacich a hosti a nastavi Service
                        if (!simple) {
                            if (s.game) {
                                var g = s.game.split(":");
                                s.Home.game = g[0];
                                s.Away.game = g[1];
                            }
                            if (s.service == "H") s.Home.service = true;
                            else if (s.service == "A") s.Away.service = true;
                        }
                    }

                    // Rozdeli parcial score na jednotlive casti
                    if (s.parcial && (s.partially = s.parcial.split(",")).length) {

                        s.partiallyTitle = [], s.parcial = "";
                        if (!simple) {
                            s.Home.partially = [], s.Away.partially = [];
                        }

                        var p = [];
                        $.each(s.partially, function (i, partially) {

                            partially = partially.split("=");

                            if (i != 0) s.parcial += ", ";
                            s.parcial += partially[1];

                            s.partiallyTitle.push(partially[0]);
                            p.push(partially[1]);

                            // Rozdeli skore podla domacich a hosti
                            if (!simple) {
                                partially = partially[1].split(":");

                                s.Home.partially.push(partially[0]);
                                s.Away.partially.push(partially[1]);
                            }
                        });
                        s.partially = p;
                    }
                }

                // Rozdeli total score a karty podla domacich a hosti
                if (!simple) {

                    // Total Score
                    s.Home.total = s.total.split(":")[0];
                    s.Away.total = s.total.split(":")[1];

                    // Cards
                    if (s.cardsYellow) {
                        s.Home.cardsYellow = (s.cardsYellow.split(":")[0] != "0") ? s.cardsYellow.split(":")[0] : "-";
                        s.Away.cardsYellow = (s.cardsYellow.split(":")[1] != "0") ? s.cardsYellow.split(":")[1] : "-";
                    }
                    if (s.cardsRed) {
                        s.Home.cardsRed = (s.cardsRed.split(":")[0] != "0") ? s.cardsRed.split(":")[0] : "-";
                        s.Away.cardsRed = (s.cardsRed.split(":")[1] != "0") ? s.cardsRed.split(":")[1] : "-";
                    }
                    if (s.corners) {
                        s.Home.corners = (s.corners.split(":")[0] != "0") ? s.corners.split(":")[0] : "-";
                        s.Away.corners = (s.corners.split(":")[1] != "0") ? s.corners.split(":")[1] : "-";
                    }
                    if (s.powerPlay) {
                        var pp = s.powerPlay.split(":")[0] - s.powerPlay.split(":")[1];
                        if (pp > 0) {
                            s.Home.powerPlay = pp;
                        } else if (pp < 0) {
                            s.Away.powerPlay = Math.abs(pp);
                        } else {
                            s.Home.powerPlay = s.Away.powerPlay = "-";
                        }
                    }
                    if (s.overtime) {
                        s.Home.overtime = [];
                        s.Away.overtime = [];

                        $.each(s.overtime, function (i, partialOvertime) {
                            s.Home.overtime.push(partialOvertime.split(":")[0]);
                            s.Away.overtime.push(partialOvertime.split(":")[1]);
                        });
                    }
                    if (s.penalties) {
                        s.Home.penalties = s.penalties.split(":")[0];
                        s.Away.penalties = s.penalties.split(":")[1];
                    }
                }

                // Vrati vytvoreny object so score
                return (s);
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia vytvara power play v kurzovej ponuke a detaile zapasu
    resolvePowerPlay(parsedScore, sportsID, team, isForEventDetail) {
        try {
            if (sportsID === 53 && parsedScore[team] && parsedScore[team].powerPlay && parsedScore[team].powerPlay > 0) {
                if (isForEventDetail) {
                    return '<div class="icon-pp-in-rectangle pp-card"></div><div class="pp-number"> + ' + parsedScore[team].powerPlay + '</div>';
                } else {
                    return '<span class="icon-pp-in-rectangle pp-card"></span>';
                }
            }
            return '';
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return '';
        }
    },

    // Zaokruhlenie na dve desatine smerom nadol (presne do 1e+8)
    floor2(figure, format) {
        try {
            // Ak je pocet znakov pred desatinou ciarkou vacsi ako 9 tak druhe desatine miesto zaokruhli matematicky
            if (Math.round(figure).toString().length > 9) {
                figure = parseFloat(figure);
            } else {
                // Inak ho zaokruhli nadol (chyba v js sa prenasa na 13-16te desatine miesto)
                figure = (parseInt(parseFloat((figure * 100).toPrecision(12))) / 100);
            }
            // Formatuje vysledok (ciarka na miesto bodky)
            if (format) if (format == 1) {
                fig = figure.toFixed(2).toString().split('.');
                figure = shared.formatNumber(fig[0], false) + ',' + fig[1];
            } else {
                figure = figure.toFixed(2);
            }
            return figure;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia formatuje cislo pred desatinnou ciarkou do formatu s medzerami na 3 cifry
    formatNumber(numToFormat, isDecimal) {
        try {
            var left = numToFormat.toString();
            if (isDecimal) {
                left = numToFormat.split(".")[0];
            }
            return left.replace(new RegExp("^(\\d{" + (left.length%3?left.length%3:0) + "})(\\d{3})", "g"), "$1 $2").replace(/(\d{3})+?/gi, "$1 ").trim() + (isDecimal? "." + numToFormat.split(".")[1]: "");
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    }
};
